import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import Sidebar from '../Sidebar/Sidebar'; // Adjust path if necessary
import './InventoryItem.css';

const InventoryItem = () => {
  const [inventory, setInventory] = useState([]);
  const [filteredInventory, setFilteredInventory] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const token = localStorage.getItem('access_token');

  // Fetch inventory on mount
  useEffect(() => {
    const fetchInventory = async () => {
      if (!token) {
        setError('User not authenticated');
        return;
      }

      try {
        const res = await axios.get('http://127.0.0.1:8000/pharmacies/get_inventory', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setInventory(res.data);
        setFilteredInventory(res.data);
        setError('');
      } catch (err) {
        setError('Failed to load inventory.');
        console.error(err);
      }
    };

    fetchInventory();
  }, [token]);

  // Filter inventory based on searchTerm
  useEffect(() => {
    if (!Array.isArray(inventory)) {
      setFilteredInventory([]);
      return;
    }
    const filtered = inventory.filter(item =>
      item.drug_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredInventory(filtered);
  }, [searchTerm, inventory]);

  // Edit handler
  const handleEdit = (id) => {
    alert(`Edit item with ID: ${id}`);
    // Add your edit logic here
  };

  // Delete handler
  const handleDelete = (id) => {
    alert(`Delete item with ID: ${id}`);
    // Add your delete logic here
  };

  return (
    <div className="inventory-page-container">
      <Sidebar />

      <section className="section inventory-section">
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <input
          type="text"
          placeholder="Search inventory by name..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <h3>Inventory Items</h3>
        <ul>
          {filteredInventory.length === 0 ? (
            <li>No inventory items found.</li>
          ) : (
            filteredInventory.map(item => (
              <li key={item.id} className="inventory-item">
                <span>
                  <strong>{item.drug_name}</strong><br />
                  Qty: {item.quantity} | Price: ₦{item.price} | Exp: {item.expiration_date} <br />
                  Form: {item.dosage_form} | Strength: {item.strength} | Cat: {item.category}
                </span>
                <div>
                  <button className="edit-btn" onClick={() => handleEdit(item.id)}>
                    <FaEdit />
                  </button>
                  <button className="delete-btn" onClick={() => handleDelete(item.id)}>
                    <FaTrash />
                  </button>
                </div>
              </li>
            ))
          )}
        </ul>
      </section>
    </div>
  );
};

export default InventoryItem;
